import(/* webpackMode: "eager" */ "/home/futurasit/RELSA/fs-negotium/apps/customer-portal/app/[lng]/loading.tsx");
